import Button from 'components/atoms/button/Button';
import EmptyEntity from 'components/atoms/empty-entity/EmptyEntity';
import Headline from 'components/atoms/headline/Headline';
import Icon from 'components/atoms/icon/Icon';
import Input from 'components/atoms/input/Input';
import LoadingScreen from 'components/atoms/loading-screen/LoadingScreen';
import NoDataBoundary from 'components/atoms/no-data-boundary/NoDataBoundary';
import DashboardBoxTitle from 'components/atoms/title/DashboardBoxTitle';
import PaginationControls from 'components/molecules/pagination-controls/PaginationControls';
import Table from 'components/molecules/table/Table';
import DashboardBoxLayout from 'components/templates/dashboard-box-layout/DashboardBoxLayout';
import { IconType } from 'lib/helpers/constants/iconTypes';
import { useQualityCheckCustomers } from 'lib/hooks/queries/Coustomer/useQualityCheckCustomers';
import { useStatusStyle } from 'lib/hooks/shared/getStatusColorCustomer';
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import UpdateQualityCheck from './update-quality-check/UpdateQualityCheck';
import { useQualityCheckQuestions } from 'lib/hooks/queries/Coustomer/useQualityCheckQuestions';

const QualityCheckView = () => {



    const [IsUpdateModalData, setIsUpdateModalData] = useState<any>(null);

    const [filterData, setFilterData] = useState({
        filter_search: "",
    });
    const handleCellClick = (row: any) => {
        setIsUpdateModalData(row.original);
    };

    const { t } = useTranslation();

    const { data: questionData, isLoading: QuestionIsLoading } = useQualityCheckQuestions();

    const [StatusFilter, setStatusFilter] = useState('')

    const {
        currentPage,
        data,
        handleItemsPerPageChange,
        handleNextPage,
        handlePreviousPage,
        itemsPerPage,
        hasNextPage,
        hasPreviousPage,
        isLoading,
    } = useQualityCheckCustomers(
        filterData.filter_search,
        StatusFilter
    );

    const columns = useMemo(() => {
        return [
            {
                id: 1,
                Header: "ID",
                accessor: "id",
                isChecked: true,
                Cell: ({ row }: any) => (
                    <div onClick={() => handleCellClick(row)} className="cursor-pointer">
                        {row.original.id}
                    </div>
                ),
            },
            {
                id: 2,
                Header: t("First Name"),
                accessor: "first_name",
                isChecked: true,
                Cell: ({ row }: any) => (
                    <div onClick={() => handleCellClick(row)} className="cursor-pointer">
                        {row.original.first_name}
                    </div>
                ),
            },
            {
                id: 3,
                Header: t("Last Name"),
                accessor: "last_name",
                isChecked: true,
                Cell: ({ row }: any) => (
                    <div onClick={() => handleCellClick(row)} className="cursor-pointer">
                        {row.original.last_name}
                    </div>
                ),
            },
            {
                id: 4,
                Header: t("Phone Number"),
                accessor: "phone",
                isChecked: true,
                Cell: ({ row }: any) => (
                    <div onClick={() => handleCellClick(row)} className="cursor-pointer">
                        {row.original.phone}
                    </div>
                ),
            },
            {
                id: 5,
                Header: t("Consultant"),
                accessor: "from_user",
                isChecked: true,
                Cell: ({ row }: any) => (
                    <div onClick={() => handleCellClick(row)} className="cursor-pointer">
                        {row.original.from_user}
                    </div>
                ),
            },
            {
                id: 6,
                Header: t("Mandated"),
                accessor: "mandated",
                isChecked: true,
                Cell: ({ row }: any) => (
                    <div onClick={() => handleCellClick(row)} className="cursor-pointer">
                        {row.original.mandated === 1 ? t("Yes") : t("No")}
                    </div>
                ),
            },
            {
                id: 7,
                Header: t("Status"),
                accessor: "company",
                Cell: ({ row }: any) => {
                    const statusStyle = useStatusStyle('Quality');
                    return (
                        <p
                            style={statusStyle}
                            className="min-w-[50px] w-[max-content] h-[24px] p-3 text-[12px] font-inter-medium flex items-center justify-center rounded-[4px] capitalize cursor-pointer"
                            onClick={() => handleCellClick(row)}
                        >
                            {t('Quality')}
                        </p>
                    )
                },
                isChecked: true,
            },

            {
                id: 'actions',
                Header: "",
                accessor: "actions",
                Cell: ({ row: { original } }: any) => {
                    return (
                        <Button
                            onClick={() => {
                                setIsUpdateModalData(original);
                            }}
                        >
                            <Icon iconType={IconType.OPTIONS_ICON} />
                        </Button>
                    );
                },
                isChecked: true,
            },
        ]
    }, [t]);


    const handleTabChange = (value: string) => {

        setStatusFilter(value);

    };

    return (
        <>
            <div className='flex xl:items-center justify-between gap-5 flex-col xl:flex-row mt-[46px] mb-[33px] pb-5'>
                <Headline title="Quality Check" className='!mt-0 !mb-0' />
                <div className="bg-white p-1 rounded-[8px] flex items-center md:w-full xl:max-w-[550px] border-[1px] border-[#F2F4F7]">
                    <Button
                        onClick={() => {
                            handleTabChange('');

                        }}
                        className={`text-white w-full text-[14px] lg:text-[16px] rounded-[8px] p-2 font-inter-medium lg:min-w-[138.34px] cursor-pointer ${StatusFilter === ''
                            ? `bg-[--theme]`
                            : "bg-transparent !text-primaryTextColor"
                            }`}
                    >
                        {t('Open')}
                    </Button>
                    <Button
                        onClick={() => {
                            handleTabChange('pending');

                        }}
                        className={`text-white w-full text-[14px] lg:text-[16px] rounded-[8px] p-2 font-inter-medium lg:min-w-[138.34px] cursor-pointer ${StatusFilter === 'pending'
                            ? `bg-[--theme]`
                            : "bg-transparent !text-primaryTextColor"
                            }`}
                    >
                        {t('Pending')}
                    </Button>
                    <Button
                        onClick={() => {
                            handleTabChange('not_reached');

                        }}
                        className={`text-white w-full text-[14px] lg:text-[16px] rounded-[8px] p-2 font-inter-medium lg:min-w-[138.34px] cursor-pointer ${StatusFilter === 'not_reached'
                            ? `bg-[--theme]`
                            : "bg-transparent !text-primaryTextColor"
                            }`}
                    >
                        {t('Not reached')}
                    </Button>
                </div>
                <Headline title="Quality Check" className='!mt-0 !mb-0 invisible hidden xl:block' />
            </div>

            <DashboardBoxLayout>
                <div className="mb-5">
                    <DashboardBoxTitle title={`${t("Quality Check")}`} />
                </div>

                <div className="flex gap-3 items-center justify-end mb-5 flex-wrap md:flex-nowrap">
                    <div className="flex-1 basis-full md:basis-auto">
                        <Input
                            icon={IconType.SEARCH_ICON}
                            className=" border-0 !border-[#F2F4F7] indent-[35px] h-[48px] !rounded-[8px] text-[#7D8592] font-inter-regular shadow-customsecondary"
                            classes={{ icon: "left-4 !top-[30%]" }}
                            placeholder={t("Search")}
                            value={filterData?.filter_search ?? ""}
                            onChange={(e) =>
                                setFilterData((prevFormData: any) => ({
                                    ...prevFormData,
                                    filter_search: e.target.value,
                                }))
                            }
                            maxLength={20}
                        />
                    </div>

                </div>


                <div className="relative">
                    {(isLoading || QuestionIsLoading) ? <div className='relative py-10'><LoadingScreen /></div> : (

                        <NoDataBoundary
                            condition={data?.pages?.[0]?.data?.data?.length > 0}
                            fallback={
                                <EmptyEntity
                                    name={t("Customers")}
                                    full_string={`We couldn't find any Customers. Please check back later or add new Customers`}
                                />
                            }
                        >
                            <Table
                                key={currentPage}
                                data={data?.pages[0]?.data?.data ?? []}
                                columns={columns}
                                search=''
                            />
                        </NoDataBoundary>
                    )}
                </div>

            </DashboardBoxLayout>
            <PaginationControls
                itemsPerPage={itemsPerPage}
                handleItemsPerPageChange={(value: number) =>
                    handleItemsPerPageChange(value)
                }
                from={data?.pages[0]?.data?.from}
                to={data?.pages[0]?.data?.to}
                total={data?.pages[0]?.data?.total}
                hasNextPage={hasNextPage}
                hasPreviousPage={hasPreviousPage}
                handleNextPage={handleNextPage}
                handlePreviousPage={handlePreviousPage}
            />
            {/* Modal Part */}
            <UpdateQualityCheck
                customer_data={IsUpdateModalData}
                onConfirm={() => {
                    setIsUpdateModalData(null);
                }}
                questions={questionData?.data}
                hocisOpen={IsUpdateModalData !== null}
                hocToggleModal={() => {
                    setIsUpdateModalData(null);
                }}
                hocCurrentStep={1}
                hocTitle={t("Update") + " " + IsUpdateModalData?.first_name + " " + IsUpdateModalData?.last_name}
                hocClasses={{
                    modalClassName: 'w-full sm:max-w-[800px]',
                }}
            />
        </>
    );
};


export default QualityCheckView